import { Component, Inject, Optional } from '@angular/core';


@Component({
  selector: 'back-navigation',
  templateUrl: './back-navigation.component.html'
})
export class BackNavigationComponent {
  isBackNavigationEnabled: boolean = false;
  backNavigationURL: string = "";
  backNavigationText:string="";
  constructor(
    @Optional() @Inject('AppSettings') appSettings: any) {
      if (appSettings.ibdConfigMap?.backNavigationConfig && appSettings.ibdConfigMap.backNavigationConfig?.enabled) {
        this.isBackNavigationEnabled = true;
        this.backNavigationURL= appSettings.ibdConfigMap.backNavigationConfig.url;
        this.backNavigationText= appSettings.ibdConfigMap.backNavigationConfig.text;
      }
  }
}